import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "d-flex align-end" }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WebWorker = _resolveComponent("WebWorker")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_emmieSiteLogo = _resolveComponent("emmieSiteLogo")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_ActivateEingabe = _resolveComponent("ActivateEingabe")!
  const _component_v_bottom_navigation = _resolveComponent("v-bottom-navigation")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      ($setup.isAuthNb == 3)
        ? (_openBlock(), _createBlock(_component_v_app_bar, {
            key: 0,
            elevation: 2,
            rounded: "",
            class: "justify-end noShadow pt-2",
            style: {"box-shadow":"none !important","background":"none"}
          }, {
            append: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                ($setup.isAuthNb == 3 && $options.hasBackend($setup.isUser) != false)
                  ? (_openBlock(), _createBlock(_component_WebWorker, {
                      key: 0,
                      class: "align-self-start mx-3",
                      isUser: { isUser: $setup.isUser }
                    }, null, 8, ["isUser"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_btn, {
                  to: "profile",
                  link: "",
                  class: "mr-2 ml-3 px-1",
                  style: {"font-size":"15px","font-weight":"bolder","color":"#E88830","box-shadow":"none"},
                  varinat: "text",
                  ripple: false,
                  density: "compact"
                }, {
                  default: _withCtx(() => [
                    ( typeof $setup.isUser != "undefined" )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString($options.getName($setup.isUser)), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, { to: "/settingsMainComponent" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      icon: "mdi-account-cog",
                      ripple: false,
                      variant: "text",
                      density: "compact"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          color: "grey-darken-4",
                          size: "small"
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.$route.name == 'Übersicht' && $setup.isAuthNb == 3)
        ? (_openBlock(), _createBlock(_component_v_app_bar, {
            key: 1,
            elevation: 0,
            class: "homeHeader",
            style: {"box-shadow":"none !important","background":"#ffffff","top":"0px","height":"150px","border-bottom":"1px solid darkgrey"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_emmieSiteLogo, {
                siteName: _ctx.$route.name,
                logoVariant: "logoTextImgTop"
              }, null, 8, ["siteName"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.$route.name == 'Datenschutz' && $setup.isAuthNb == 3)
        ? (_openBlock(), _createBlock(_component_v_app_bar, {
            key: 2,
            elevation: 0,
            class: "homeHeader",
            style: {"box-shadow":"none !important","background":"#ffffff","top":"0px","height":"150px","border-bottom":"1px solid darkgrey"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_emmieSiteLogo, {
                siteName: _ctx.$route.name,
                logoVariant: "logoTextImgTop"
              }, null, 8, ["siteName"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.$route.name == 'Kalender' && $setup.isAuthNb == 3)
        ? (_openBlock(), _createBlock(_component_v_app_bar, {
            key: 3,
            elevation: 0,
            class: "homeHeaderLong",
            style: {"box-shadow":"none !important","background":"#ffffff","top":"0px","height":"205px","border-bottom":"1px solid darkgrey"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_emmieSiteLogo, {
                siteName: _ctx.$route.name,
                logoVariant: "logoImgTop"
              }, null, 8, ["siteName"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      ((_ctx.$route.name != 'Übersicht') && (_ctx.$route.name != 'Kalender') && (_ctx.$route.name != 'Datenschutz'))
        ? (_openBlock(), _createBlock(_component_v_app_bar, {
            key: 4,
            elevation: 0,
            class: "homeHeaderSmall",
            style: {"box-shadow":"none !important","background":"#ffffff","top":"0px","height":"100px","border-bottom":"1px solid darkgrey"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_emmieSiteLogo, {
                siteName: _ctx.$route.name,
                logoVariant: "logoImgTop"
              }, null, 8, ["siteName"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_main, {
        scrollable: "",
        class: "mx-auto my-auto"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_container, { class: "py-0" }, {
            default: _withCtx(() => [
              _createVNode(_component_router_view)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      ($setup.isAuthNb == 3)
        ? (_openBlock(), _createBlock(_component_v_bottom_navigation, {
            key: 5,
            elevation: 5
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_menu, {
                left: "",
                bottom: ""
              }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_btn, _mergeProps({ icon: "" }, props), {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-share-variant-outline")
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" Teilen ")
                    ]),
                    _: 2
                  }, 1040)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            to: "persona",
                            link: "",
                            class: "elevation-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Persona ")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_list_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            to: "report",
                            link: "",
                            class: "elevation-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Bericht erstellen ")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                to: "calendar",
                link: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-calendar-blank-outline")
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" Kalender ")
                ]),
                _: 1
              }),
              _createVNode(_component_ActivateEingabe),
              _createVNode(_component_v_menu, {
                left: "",
                bottom: ""
              }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_btn, _mergeProps({ icon: "" }, props), {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-chart-line")
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" Analyse ")
                    ]),
                    _: 2
                  }, 1040)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            to: "analyze",
                            link: "",
                            class: "elevation-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Analyse ")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_list_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            to: "cyleview",
                            link: "",
                            class: "elevation-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Zyklusansicht ")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                to: "knowledge",
                link: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-book-open-page-variant-outline")
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" Wissen ")
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}